// src/components/MedicineMapping.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getDiseaseMedicineMappingsAction,
  deleteDiseaseMedicineMappingAction,
} from "../../../store/actions/DiseaseMedicineMappingAction";
import swal from "sweetalert";
import Loader from "../Common/Loader";

const MedicineMapping = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mappings = useSelector(
    (state) => state.diseaseMedicineMappings?.mappings || []
  );


  const [searchQueries, setSearchQueries] = useState({
    disease_medicine_id: "",
    disease_name: "",
    medicine_name: "",
    medicine_type: "",
    status: "",
  });
  const [sortField, setSortField] = useState("disease_medicine_id");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 10;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("")

  // useEffect(() => {
  //   const fetchDiseaseMedicine = async () => {
  //     setLoading(true);
  //     setError("");

  //     try {
  //       await dispatch(getDiseaseMedicineMappingsAction());
  //     } catch (err) {
  //       console.error("Failed to fetch Disease Medicine:", err);
  //       setError("Failed to load Disease Medicine. Please try again.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchDiseaseMedicine();
  // }, [dispatch]);


  // const handleSearch = (e, field) => {
  //   setSearchQueries({ ...searchQueries, [field]: e.target.value });
  //   setCurrentPage(0);
  // };
  const fetchMappingsFromServer = async (
    search_by = "",
    search_keyword = "",
    pagination = true,
    pageid = 0,
    sort_by = "",
    sort_order = "",
  ) => {
    try {
      await dispatch(getDiseaseMedicineMappingsAction(pagination, pageid, search_by, search_keyword,sort_by, sort_order));
    } catch (err) {
      console.error("Failed to fetch mappings:", err);
      setError("Failed to load mappings.");
    }
  };

  useEffect(() => {
    const fetchMappings = async () => {
      setLoading(true);
      setError("");

      try {
        await fetchMappingsFromServer();
      } catch (err) {
        console.error("Failed to fetch mappings:", err);
        setError("Failed to load mappings.");
      } finally {
        setLoading(false);
      }
    };

    fetchMappings();
  }, [dispatch]);

  const handleSearch = (e, field) => {
    const keyword = e.target.value;
    const updatedQueries = { ...searchQueries, [field]: keyword };
    setSearchQueries(updatedQueries);
    setCurrentPage(0);

    fetchMappingsFromServer(field, keyword);
  };


  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
  
    setSortField(field);
    setSortOrder(order);
    setCurrentPage(0);
  
    const [search_by] = Object.keys(searchQueries).filter(
      (key) => searchQueries[key]?.trim() !== ""
    );
    const search_keyword = search_by ? searchQueries[search_by] : "";
  
    fetchMappingsFromServer(search_by || "", search_keyword, true, 0, field, order);
  };

  const handleEdit = (mapping) => {
    navigate("/add-medicinemapping", { state: { mapping } });
  };


  const handleDelete = (mapping) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this mapping!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          await dispatch(deleteDiseaseMedicineMappingAction(mapping));
        } catch (err) {
          setError("Failed to delete Disease Medicine Mapping");
          console.error("Delete failed:", err);
        } finally {
          setLoading(false);
        }
      }
    });
  };


  const filtered = mappings
    .filter((m) =>
      Object.entries(searchQueries).every(
        ([key, val]) =>
          !val ||
          m[key]?.toString().toLowerCase().includes(val.toLowerCase())
      )
    )
    .sort((a, b) => {
      const mod = sortOrder === "asc" ? 1 : -1;
      return (
        a[sortField]?.toString().localeCompare(b[sortField]?.toString()) *
        mod
      );
    });

  const paginated = filtered.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );
  const totalPages = Math.ceil(filtered.length / rowsPerPage);

  return (
    <>
      <div className="row mb-3">
        <div className="col-12 text-end">
          <Link
            to="/add-medicinemapping"
            className="btn btn-primary btn-rounded"
          >
            + Add Mapping
          </Link>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {error && <div className="text-danger mb-2">{error}</div>}

          {loading ? (
            <div className="text-center my-5">
              <Loader size="lg" />
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-striped mb-4">
                  <thead className="table-light">
                    <tr>
                      <th onClick={() => handleSort("disease_medicine_id")}>
                        ID{" "}
                        {sortField === "disease_medicine_id" &&
                          (sortOrder === "asc" ? "↑" : "↓")}
                        <input
                          className="form-control form-control-sm mt-1"
                          value={searchQueries.disease_medicine_id}
                          onChange={(e) =>
                            handleSearch(e, "disease_medicine_id")
                          }
                          placeholder="Search ID"
                        />
                      </th>

                      <th onClick={() => handleSort("disease_name")}>
                        Disease{" "}
                        {sortField === "disease_name" &&
                          (sortOrder === "asc" ? "↑" : "↓")}
                        <input
                          className="form-control form-control-sm mt-1"
                          value={searchQueries.disease_name}
                          onChange={(e) => handleSearch(e, "disease_name")}
                          placeholder="Search Disease"
                        />
                      </th>

                      <th onClick={() => handleSort("medicine_name")}>
                        Medicine{" "}
                        {sortField === "medicine_name" &&
                          (sortOrder === "asc" ? "↑" : "↓")}
                        <input
                          className="form-control form-control-sm mt-1"
                          value={searchQueries.medicine_name}
                          onChange={(e) => handleSearch(e, "medicine_name")}
                          placeholder="Search Medicine"
                        />
                      </th>

                      <th onClick={() => handleSort("medicine_type")}>
                        Type{" "}
                        {sortField === "medicine_type" &&
                          (sortOrder === "asc" ? "↑" : "↓")}
                        <input
                          className="form-control form-control-sm mt-1"
                          value={searchQueries.medicine_type}
                          onChange={(e) => handleSearch(e, "medicine_type")}
                          placeholder="Search Type"
                        />
                      </th>

                      <th onClick={() => handleSort("status")}>
                        Status{" "}
                        {sortField === "status" &&
                          (sortOrder === "asc" ? "↑" : "↓")}
                        <input
                          className="form-control form-control-sm mt-1"
                          value={searchQueries.status}
                          onChange={(e) => handleSearch(e, "status")}
                          placeholder="Search Status"
                        />
                      </th>

                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginated.map((m) => (
                      <tr key={m.disease_medicine_id}>
                        <td>{m.disease_medicine_id}</td>
                        <td>{m.disease_name}</td>
                        <td>{m.medicine_name}</td>
                        <td>{m.medicine_type}</td>
                        <td>
                          <span
                            className={`badge px-3 py-1 rounded-pill text-white ${m.status.toLowerCase() === "active"
                                ? "bg-success"
                                : "bg-danger"
                              }`}
                          >
                            {m.status}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex">
                            <span
                              className="me-3"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEdit(m)}
                              title="Edit Mapping"
                            >
                              <i className="fa fa-pencil-alt text-success"></i>
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDelete(m)}
                              title="Delete Mapping"
                            >
                              <i className="fa fa-trash text-danger"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}

                    {paginated.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No mappings found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "20px",
                  gap: "10px",
                }}
              >
                <div style={{ fontSize: "14px" }}>
                  Showing {filtered.length === 0 ? 0 : currentPage * rowsPerPage + 1} to{" "}
                  {Math.min((currentPage + 1) * rowsPerPage, filtered.length)} of {filtered.length} entries
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", justifyContent: "center" }}>
                  {/* Prev */}
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                    disabled={currentPage === 0}
                    style={{
                      padding: "6px 12px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      color: "#000",
                      cursor: currentPage === 0 ? "not-allowed" : "pointer",
                      opacity: currentPage === 0 ? 0.5 : 1,
                    }}
                  >
                    &lt;
                  </button>

                  {/* Pages */}
                  {(() => {
                    const pages = [];
                    const maxPagesToShow = 5;
                    const startPage = Math.max(0, Math.min(currentPage - 2, totalPages - maxPagesToShow));
                    const endPage = Math.min(startPage + maxPagesToShow, totalPages);

                    if (startPage > 0) {
                      pages.push(
                        <button
                          key={0}
                          onClick={() => setCurrentPage(0)}
                          style={{
                            padding: "6px 12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            color: "#000",
                            cursor: "pointer",
                          }}
                        >
                          1
                        </button>
                      );
                      if (startPage > 1) {
                        pages.push(
                          <span key="dots1" style={{ padding: "6px 12px" }}>
                            ...
                          </span>
                        );
                      }
                    }

                    for (let i = startPage; i < endPage; i++) {
                      const isActive = currentPage === i;
                      pages.push(
                        <button
                          key={i}
                          onClick={() => setCurrentPage(i)}
                          style={{
                            padding: "6px 12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: isActive ? "#007bff" : "#fff",
                            color: isActive ? "#fff" : "#000",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      );
                    }

                    if (endPage < totalPages) {
                      if (endPage < totalPages - 1) {
                        pages.push(
                          <span key="dots2" style={{ padding: "6px 12px" }}>
                            ...
                          </span>
                        );
                      }
                      pages.push(
                        <button
                          key={totalPages - 1}
                          onClick={() => setCurrentPage(totalPages - 1)}
                          style={{
                            padding: "6px 12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            color: "#000",
                            cursor: "pointer",
                          }}
                        >
                          {totalPages}
                        </button>
                      );
                    }

                    return pages;
                  })()}

                  {/* Next */}
                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                    disabled={currentPage === totalPages - 1}
                    style={{
                      padding: "6px 12px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      color: "#000",
                      cursor: currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                      opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                    }}
                  >
                    &gt;
                  </button>
                </div>
              </div>

            </>
          )}
        </div>
      </div>
    </>

  );
};

export default MedicineMapping;
